import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { CardBody } from 'reactstrap';
import { LOGIN_ALERT_REMOVE } from '../../actions/types';
import PropTypes from 'prop-types';
import store from '../../store';
import { forgotPassword } from '../../api/login/auth';

const ForgotPassword = ({
  forgotPassword,
  isAuthenticated,
  isError,
  errMessage,
  isErrorType,
  history,
}) => {
  const [email, setEmail] = useState('');
  const [showmsg, setShowmsg] = useState('d-none');
  const [showEmsg, setShowEmsg] = useState('d-none');
  const [redir, setRedir] = useState(false);

  useEffect(() => {
    if (isError && isErrorType === 'RESET_FAILED') {
      setShowmsg('d-none');
      setShowEmsg('');
      setTimeout(() => {
        store.dispatch({
          type: LOGIN_ALERT_REMOVE,
        });
      }, 12000);
    } else if (isError && isErrorType === 'RESET_SUCCESS') {
      setShowmsg('');
      setShowEmsg('d-none');
      setTimeout(() => {
        store.dispatch({
          type: LOGIN_ALERT_REMOVE,
        });
        setRedir(true);
      }, 5000);
    } else {
      setShowmsg('d-none');
      setShowEmsg('d-none');
    }
  }, [isError, isErrorType]);
  const onChange = (e) => setEmail(e.target.value);
  const onSubmit = async (e) => {
    e.preventDefault();
    if (email !== '') {
      await forgotPassword(email);
    }
  };
  if (isAuthenticated) {
    return <Redirect to='/company-management' />;
  }
  if (redir) {
    return (
      <Redirect
        to={'/update-password?user_email=' + encodeURIComponent(email)}
      />
    );
  }
  return (
    <Fragment>
      <div
        style={{
          width: '100%',
          borderRadius: '0px',
        }}
        className=' py-3 px-3 mt-4'
      >
        <CardBody className='pt-3 pb-3 pl-3 pr-3'>
          <form
            className='form-signin mt-0 mb-0 p-0'
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit(e);
            }}
          >
            <h3 className='mb-2'>Forgot Password?</h3>
            <p className='mb-3 pb-2'>Please enter email to proceed</p>
            <div className='form-group'>
              {/* <label>Email</label> */}
              <input
                type='email'
                className='form-control'
                placeholder='Email'
                name='email'
                value={email}
                onChange={(e) => onChange(e)}
                style={{ fontSize: '16px', height: '44px' }}
                autoFocus
                required
              />
            </div>
            <div className='form-group'>
              <button
                className='btn btn-lg mb-2 mt-4 btn-primary btn-block btn-signin'
                type='submit'
              >
                Proceed
              </button>
              <div className='col-12' style={{ overflow: 'auto' }}>
                <Link
                  to='/login'
                  style={{
                    width: '100%',
                    textAlign: 'right',
                    float: 'right',
                  }}
                  data-original-title=''
                  title=''
                >
                  Login
                </Link>
              </div>
              <div className={'col-12 p-0 m-0 ' + showmsg}>
                <div
                  className='alert alert-success alert-dismissible fade show mt-3 mb-0'
                  role='alert'
                >
                  {errMessage}
                </div>
              </div>
              <div className={'col-12 p-0 m-0 ' + showEmsg}>
                <div
                  className='alert alert-danger alert-dismissible fade show mt-3 mb-0'
                  role='alert'
                >
                  {errMessage}
                </div>
              </div>
            </div>
          </form>
        </CardBody>
      </div>
    </Fragment>
  );
};

ForgotPassword.propTypes = {
  forgotPassword: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  isError: PropTypes.bool,
  isErrorType: PropTypes.string,
  errMessage: PropTypes.string,
};
const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isError: state.auth.isError,
  errMessage: state.auth.errMessage,
  isErrorType: state.auth.isErrorType,
});
export default connect(mapStateToProps, { forgotPassword })(ForgotPassword);
